import cn from "classnames";
import { CloseIcon, WarningIcon } from "components/ui/Icons";
import type { CreatedApiKey } from "hooks/useApiKeys";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";

type RevealedKeyProps = {
  createdKey: CreatedApiKey;
  onDismiss: () => void;
};

/**
 * The back office stores only a hash, so this banner is the one and only time
 * the key can be read. It stays until the user closes it deliberately.
 */
export const RevealedKey = ({ createdKey, onDismiss }: RevealedKeyProps) => {
  const { copied, copy } = useCopyToClipboard();

  return (
    <div className="pc-warn">
      <div className="pc-warn__top">
        <WarningIcon className="pc-warn__ico" />
        <div>
          <div className="pc-warn__h">Copy “{createdKey.name}” now</div>
          <p className="pc-warn__t">
            This is the only time the key is shown. Once you close this box it cannot be recovered — you would have to
            create a new one.
          </p>
        </div>
        <button type="button" className="pc-warn__x" aria-label="Dismiss" onClick={onDismiss}>
          <CloseIcon />
        </button>
      </div>

      <div className="pc-warn__row">
        <code className="pc-warn__key">{createdKey.token}</code>
        <button
          type="button"
          className={cn("pcbtn", { "is-copied": copied })}
          onClick={() => void copy(createdKey.token)}
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
};
